import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  PACKAGE_CREATE,
  PACKAGE_EDIT,
  PACKAGE_VIEW,
} from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import ListFilterMenu from '../../../../../shared/list-filter-menu/List-Filter-Menu';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  accommodationPackageActivate,
  accommodationPackageDeactivate,
  deleteAccommodationPackageAPI,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  allPackagesSelector,
  fetchAllAccommodations,
  selectedHotelCurrencySelector,
  setAllPackages,
} from '../../../../property/propertySlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  generateConfirmationMessage,
  ResetFilterList,
  PARTIAL_CHECKBOX_GREEN,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const PackagesList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;

  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const originalPackages = useSelector(allPackagesSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [packages, setPackages] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const [filterMenu, setFilterMenu] = useState([]);
  const dispatch = useDispatch();
  const searchRef = useRef(null);
  const filterRef = useRef(null);
  const wrapperRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(selectedHotel);
  const resetFilterDataList = () => {
    setFilterMenu([
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
      {
        title: 'Status',
        field: 'isActive',
        subMenu: [
          { id: 'active', name: 'Active', selected: false },
          { id: 'inactive', name: 'Inactive', selected: false },
        ],
      },
    ]);
  };
  useEffect(() => {
    // Assigning data set to local list while keeping an original data set for filtering
    setSearchText('');
    setSearchButton(true);
    const withCheck = originalPackages?.map((Pack) => ({
      ...Pack,
      isChecked: false,
    }));
    setPackages(withCheck);
    setFilteredBaseList(withCheck);

    resetFilterDataList();
    setLoading(false);
  }, [originalPackages]);

  const dragDisabled = isDragDisabled(packages, searchText) || isFilterApplied?.current;

  const getCheckedpackagesList = packages?.filter((packages) => packages?.isChecked);

  const listOfPackagesIds = getCheckedpackagesList?.map((packages) => packages?.id);

  const selectedPackagesLength = getCheckedpackagesList?.length;

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(packages, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setPackages(updatedCheckedList);
  };

  useEffect(() => {
    updateSelectedModule(packages, setActionMenuList, setIsAllSelected);
  }, [packages]);

  useEffect(() => {
    if (loading || packages?.length === 0) return;
    const totalItems = packages?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [packages?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedPackagesLength) {
      setPackages(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.pack);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      pack: null,
    });
  };

  const handleCellMenuClick = (event, pack) => {
    event.stopPropagation();
    if (selectedPackagesLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: pack.id,
        name: pack.name,
        title: '',
        description: '',
        status: false,
        isActive: pack.isActive,
        anchorEl: event.currentTarget,
        pack: pack,
      });
    }
  };

  const deleteAccommodationPackage = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };
  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (selectedValue.isActive) {
      try {
        await accommodationPackageDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Package deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          pack: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Package deactivated failed',
        );
      }
    } else {
      try {
        await accommodationPackageActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Package activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          pack: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Package activated failed',
        );
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const deletePackages = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteAccommodationPackageAPI(selectedHotel, selectedValue.id, delByLang);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Package deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Package');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      pack: null,
    });
  };

  const onViewDetails = (pack, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(PACKAGE_VIEW, true, pack);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.pack) {
      onViewToggle(PACKAGE_VIEW, true, selectedValue.pack);
    }
  };

  const handleFilterMenu = (event) => {
    if (selectedPackagesLength > 0) {
      setShowBulkFilterAlert(true);
      return;
    } else {
      setFilterTargetButton(event.currentTarget);
      // setAnchorEl(event.currentTarget);
    }
  };

  const handleFilter = (filterItems, field) => {
    const updatedMenu = filterMenu?.map((menu) =>
      menu.field === field ? { ...menu, subMenu: filterItems } : menu,
    );
    setFilterMenu(updatedMenu);
    if (field === 'all') {
      setFilteredBaseList(originalPackages);
      setPackages(originalPackages);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    const anyChecked = updatedMenu?.flatMap((m) => m?.subMenu)?.some((item) => item?.selected);
    if (!anyChecked) {
      setFilteredBaseList(originalPackages);
      setPackages(originalPackages);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    isFilterApplied.current = true;
    const activeChecked = filterItems?.some((i) => i?.id === 'active' && i?.selected);
    const inactiveChecked = filterItems?.some((i) => i?.id === 'inactive' && i?.selected);
    let filtered = [];
    if ((activeChecked && inactiveChecked) || (!activeChecked && !inactiveChecked)) {
      filtered = originalPackages;
    } else if (activeChecked) {
      filtered = originalPackages?.filter((p) => p?.isActive);
    } else {
      filtered = originalPackages?.filter((p) => !p?.isActive);
    }
    setFilteredBaseList(filtered);
    setPackages(filtered);
    onsetPage(0);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = packages?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = packages?.findIndex((item) => item.id === id);
    if (!packages[index]?.isChecked) {
      packages[index] = { ...packages[index], isChecked: true };
    } else {
      packages[index].isChecked = !packages[index]?.isChecked;
    }
    setPackages([...packages]);

    let actionList = packages
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = packages?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = packages?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedPackageList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedPackageList = packages?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedPackageList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedPackageList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    setPackages([...selectedPackageList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedPackageList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Package',
    listOfPackagesIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_PACKAGE';
      await updateSelectedItemsStatus(
        listOfPackagesIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Package was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setPackages(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_PACKAGE';
      await deleteSelectedItems(
        listOfPackagesIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', 'Package deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Package',
      );
    }
    setIsAllSelected(false);
  };

  const handleContinue = (isFromFilterContinue = false) => {
    setShowBulkSearchAlert(false);
    setPackages((prev) =>
      prev.map((item) => ({
        ...item,
        isChecked: false,
      })),
    );

    setTimeout(() => {
      if (isFromFilterContinue) {
        filterRef?.current?.click();
      } else {
        searchRef?.current?.focus();
      }
    }, 0);
  };

  const handleSearchInputFocus = (e) => {
    if (selectedPackagesLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deletePackages}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedPackagesLength} ${
            selectedPackagesLength > 1 ? 'packages' : 'package'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedPackagesLength}  ${
            selectedPackagesLength > 1 ? 'packages' : 'package'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      <div className='row mx-2 d-flex'>
        <div
          className='col-md-4'
          onClick={() => {
            visible && setPopUp(true);
          }}
        >
          {packages && (
            <TextField
              className='w-100'
              inputRef={searchRef}
              focused={false}
              onChange={(e) => {
                handleSearchText(e?.target?.value);
                setSearchButton(e?.target?.value ? false : true);
              }}
              onFocus={(e) => handleSearchInputFocus(e)}
              label='Search'
              value={searchText}
              InputProps={
                searchButton && {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton className='showpopup'>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              }
            />
          )}
        </div>
        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end gap-2'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='me-4 showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={packages}
            setPlaceHolder={setPackages}
            globalPlaceHolder={originalPackages}
            setGlobalPlaceHolder={setAllPackages}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Accommodations package'
            module='ACCOMMODATION_PACKAGE'
          />
          {packages && (
            <>
              <Button
                innerRef={filterRef}
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'me-4 filterButton'
                    : 'me-4 showpopup'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={true}
              />
            </>
          )}
          {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, PACKAGE_CREATE);
              }}
              className='showpopup'
            >
              Add Package
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          packages && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedPackagesLength}
                        totalLength={originalPackages?.length}
                        inputProps={{
                          'aria-label': 'select all Packages',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-40'>Packages Name</TableCell>
                    <TableCell className='w-20'>Cost</TableCell>
                    <TableCell align='center' className='w-30'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      packages,
                      setPackages,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? packages.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : packages
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(item, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(item?.id)}
                                    checked={item?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select item ${item.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-40'>{item?.name}</TableCell>
                                <TableCell className='w-20'>
                                  {currency} {item?.costPerNight}
                                </TableCell>
                                <TableCell className='w-30' align='center'>
                                  <CustomChip
                                    label={item?.isActive ? 'Active' : 'Inactive'}
                                    color={item?.isActive ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, item);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleActivate();
                                      }}
                                    >
                                      {selectedValue.isActive === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, PACKAGE_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAccommodationPackage(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={packages.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}{' '}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onConfirm={() => {
              handleContinue(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PackagesList;
